import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import FilePreview from "../chat/FilePreview";
import EmojiPckerCom from "../chat/EmojiPckerCom";
import EmojiPicker from "emoji-picker-react";

const ModalTxtFile = ({
  file,
  setFile,
  values,
  setFormValue,
  handleInputChange,
  onHide,
  sendChatMessage,
}) => {
  const [showEmoji, setShowEmoji] = useState(false);
  const getTitle = () => {
    if (typeof file === "string") {
      return "Enviar imagen";
    } else if (file instanceof File) {
      const { name } = file;
      const extension = name.split(".").pop().toLowerCase();

      if (["mp4", "mkv", "mov"].includes(extension)) {
        return "Enviar video";
      } else if (["jpg", "png", "PNG", "JPG", "jpeg"].includes(extension)) {
        return "Enviar imagen";
      } else if (["doc", "docx", "pdf", "txt"].includes(extension)) {
        return "Enviar documento";
      } else {
        return "Enviar archivo";
      }
    }
    return "Enviar archivo";
  };
  const closeFile = () => {
    const { newMessageMod } = values;
    setFormValue({
      ...values,
      photo: "",
      newMessageMod: "",
      newMessage: newMessageMod,
    });
    setFile(null);
    onHide();
  };
  return (
    <>
      <Modal.Header>
        <div className="d-flex justify-content-between">
          <Button
            variant="link"
            className="text-secondary"
            // !pasar el txt a la otra caja de texto
            onClick={closeFile}
          >
            <i className="uil uil-times h2" />
          </Button>
          <Modal.Title>{getTitle()}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <FilePreview file={file} setFile={setFile} />
        </div>
        <Form noValidate onSubmit={sendChatMessage}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            {/* <Form.Label>Example textarea</Form.Label> */}
            <Form.Control
              as="textarea"
              rows={3}
              autoFocus
              name="newMessageMod"
              value={values.newMessageMod}
              onChange={handleInputChange}
            />
          </Form.Group>
          {showEmoji && (
            <div className="emoji-picker position-absolute start-100 top-0">
              <EmojiPicker
                onEmojiClick={(e) => {
                  setFormValue((prevValues) => ({
                    ...prevValues,
                    newMessageMod: prevValues.newMessageMod + e.emoji,
                  }));
                }}
                emojiStyle="google"
                searchPlaceHolder="Buscar emoji..."
                lazyLoadEmojis={true}
                previewConfig={{
                  showPreview: false,
                }}
                theme="auto"
                height={"330px"}
              />
            </div>
          )}
          <div className="d-flex justify-content-between">
            {" "}
            <div className="yuu">
              <Button
                className="btn-light px-1"
                onClick={() => {
                  setShowEmoji(!showEmoji);
                }}
              >
                <i className="uil uil-smile font-16" />
              </Button>
            </div>
            <Button variant="primary" type="submit">
              <i className="uil uil-message" /> Enviar
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </>
  );
};

export default ModalTxtFile;
